import React, { useState } from 'react';
import Modal from 'react-modal';
import Button from 'react-bootstrap/Button';

import empresasService from '../../../../services/Empresas';

import Swal from 'sweetalert2'
import { Select } from 'antd';
import PAISES from '../../../../constantes/paises';

const { Option } = Select;

// ESTILO DEL MODAL DE ALTA MASIVA DE EMPRESAS
const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    background            : 'white'
  }
};

const BulkNewEmpresa = ( props ) => {

  const [ country, setCountry ] = useState( props.userdata.pais )
  const [ namesText, setNamesText ] = useState( '' )

  // FUNCION DE CREACION MASIVA DE EMPRESAS
  const createCompanies = () => {

    const nombres = namesText
      .split( '\n' )
      .map( nombre => nombre.trim() )
      .filter( nombre => nombre.length > 0 )

    if ( nombres.length === 0 ){
      Swal.fire({
        icon: 'warning',
        title: 'Incompleted Fields!',
        text: 'Ingresa al menos un nombre de empresa, uno por linea.'
      })

      return;
    }

    // ALERT DE LOADING
    Swal.fire ({
       title: '..Creating the companies..',
       onBeforeOpen: () => {
         Swal.showLoading ()
       }
    })

    const jsonData = {
      nombres: nombres,
      pais: country
    }

    empresasService.postBulk( jsonData, {
      success: res => {
        Swal.close();

        if ( !res.data.ok ){

          if ( res.data.code === 1 ){
            Swal.fire({
              icon: 'error',
              title: 'Sin permisos',
              text: 'No tienes los permisos necesarios para dar de alta una empresa.'
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: res.data.info || 'No se pudieron crear las empresas.'
            })
          }

          return;
        }

        const resultados = res.data.info;
        const exitosas = resultados.filter( r => r.ok );
        const fallidas = resultados.filter( r => !r.ok );

        if ( fallidas.length === 0 ){
          Swal.fire({
            icon: 'success',
            title: 'Empresas creadas',
            text: `Se crearon ${ exitosas.length } empresas correctamente.`
          })
        } else {
          Swal.fire({
            icon: exitosas.length > 0 ? 'warning' : 'error',
            title: 'Alta masiva finalizada',
            html: `Creadas: ${ exitosas.length } / ${ resultados.length }<br/><br/>`
              + `Fallaron:<br/>`
              + fallidas.map( f => `- ${ f.nombre }: ${ f.info }` ).join( '<br/>' )
          })
        }

        setNamesText( '' )
        props.successHandler();
      }
    } )

  }

  // RENDERIZADO DEL COMPONENTE MODAL
  return (
    <div>
      <Modal
              isOpen={ props.open }
              onRequestClose={ props.handlerClose }
              style={ customStyles }
              contentLabel="Bulk Companies Modal"
              appElement={ document.getElementById('root') }
            >

        <div className="modalContainer newEmpresa bulk">
          <div className="data">
            <div className="form">
              {
                props.countryModifyable
                &&
                <div className="line country">
                  <div className="form-select">
                    <Select value={ country } style={{ width: '180px' }} onChange={ setCountry }>
                      {
                        PAISES.map( pais => <Option key={ pais.id } value={ pais.id }> { pais.name } </Option> )
                      }
                    </Select>
                  </div>
                </div>
              }
              <div className="line names">
                <div className="form-textarea">
                  <textarea
                    id="companyNamesBulk"
                    rows={ 10 }
                    placeholder={ 'Un nombre de empresa por linea\nEj:\nEmpresa 1\nEmpresa 2\nEmpresa 3' }
                    value={ namesText }
                    onChange={ e => setNamesText( e.target.value ) }
                  />
                </div>
                <div className="tag">
                  *Todas las empresas de la tanda se crean en el mismo pais seleccionado arriba.
                </div>
              </div>
            </div>
            <div className="footer">
              <Button variant="primary" onClick={ createCompanies }> Create Companies </Button>
            </div>
          </div>
        </div>

      </Modal>
    </div>
  )
}

export default BulkNewEmpresa
